import fakeData from 'api/fakeData';
import feApi from 'api/feApi';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const name = 'fe';
const initialState = {
  isCallingPayment: false,
  transaction: {},
  payment: fakeData.fakePaymentData,
  qrData: fakeData.fakeQrData,
  expiryInSeconds: 0,
};

// ---- thunks ----
export const thunkCallPayment = createAsyncThunk(
  `${name}/thunkCallPayment`,
  async (params, thunkAPI) => {
    const res = await feApi.activateChargeByQR(params);
    return res;
  }
);

const feSlice = createSlice({
  name: name,
  initialState: initialState,
  reducers: {
    resetFeSlice: (state, action) => {
      return initialState;
    },
    setData: (state, action) => {
      state.payment = action?.payload?.payment ?? {};
      state.transaction = action?.payload?.transaction ?? {};
      state.qrData = action?.payload?.qrData ?? {};
      state.expiryInSeconds = action?.payload?.expiryInSeconds ?? 0;
    },
  },
  extraReducers: {
    [thunkCallPayment.pending]: (state, action) => {
      state.isCallingPayment = true;
    },
    [thunkCallPayment.rejected]: (state, action) => {
      state.isCallingPayment = false;
    },
    [thunkCallPayment.fulfilled]: (state, action) => {
      state.isCallingPayment = false;
      const { result, transaction, payment, qrData, expiryInSeconds } = action.payload;
      if (result === 'success') {
        state.transaction = transaction;
        state.payment = payment;
        state.qrData = qrData;
        state.expiryInSeconds = expiryInSeconds;
      }
    },
  },
});

const { actions, reducer } = feSlice;
export const { resetFeSlice, setData } = actions;
export default reducer;
